import { useState } from 'react';
import { api } from '../../services/api';

export default function useSendNotification() {
  const [loading, setLoading] = useState(false);
  async function execute(title: string, message: string, driverId?: string) {
    try {
      setLoading(true);
      const response = await api.post('/push/send-notification', {
        title,
        message,
        driverId,
      });

      if (response.status === 201) {
        return response.data;
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
